import React from 'react';

const NumberCell = ({ value, scale=0.4, pdfFontSize }) => {
    let displayValue = '';
    if (typeof value === 'number' && !isNaN(value)) {
        displayValue = value.toFixed(2);
    } else if (value !== undefined && value !== null && value !== '') {
        var num = Number(value);
        displayValue = !isNaN(num) ? num.toFixed(2) : '';
    }
    return (
        <span style={{fontSize: pdfFontSize ? `${pdfFontSize}px` : `${(1/scale)/2}em`}}>{displayValue}</span>
    );
};

export default NumberCell;
